import React from 'react';
import ReservationService from '../../services/reservation';
import User from '../../services/user';
import UserStore from '../../stores/UserStore';
import ReservationStore from '../../stores/ReservationStore';
import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';
import config from '../../config';
import eliteIcon from '../../img/elite svg.svg';
import { history as browserHistory } from '../../helpers/history';

class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.onUpcomingChange = this.onUpcomingChange.bind(this);
    this.onUserChange = this.onUserChange.bind(this);
    this.state = {
      loading: false,
      user: UserStore.getUser(),
      reservations: null,
      error: '',
      downloading: null,
      resending: null,
      cities: config.cities,
      seatPopup: null,
      pending: null
    }
  }

  getStopLabel(stop) {
    return _.find(this.state.cities, {value: stop}).label;
  }

  getShortStopLabel(stop) {
    return _.find(this.state.cities, {value: stop}).shortLabel;
  }

  getStopMetro(stop) {
    return _.find(this.state.cities, {value: stop}).metro;
  }

  getStopPickup(stop) {
    return _.find(this.state.cities, {value: stop}).address;
  }

  getTime(time) {
    return moment(time, "HH:mm:ss").format("hh:mm A");
  }

  onUpcomingChange(){

    let result = ReservationStore.getUpcoming();
    if(result) {
      this.setState({reservations: result});
    }
  }

  onUserChange() {
    this.setState({user: UserStore.getUser()});
  }

  getUpcomingReservations() {
    this.setState({loading: true, error: ''});
    ReservationService.getUpcomingReservations()
    .then(() => {
      this.setState({loading: false})
    })
    .catch((err) => {
      this.setState({loading: false, error: err.response.statusText});
    });
  }

  componentDidMount() {
    ReservationStore.addUpcomingChangeListener(this.onUpcomingChange);
    UserStore.addChangeListener(this.onUserChange);
    // Points balance lives in the JWT and only changes server-side (the nightly
    // cron credits points after travel) — re-fetch so the dashboard shows the
    // credited balance without a fresh login (TRIP-102).
    User.getCreditsAndVouchers().then(() => {}).catch(() => {});
    // Authoritative pending summary — the same computation the admin panel shows.
    ReservationService.getPendingPoints()
      .then((pending) => this.setState({ pending }))
      .catch(() => {});
    this.getUpcomingReservations();
    this._handleOutsideClick = (e) => {
      if (this.state.seatPopup && !e.target.closest('.seat-popup-wrapper')) {
        this.setState({ seatPopup: null });
      }
    };
    document.addEventListener('click', this._handleOutsideClick);
  }

  componentWillUnmount() {
    ReservationStore.removeUpcomingChangeListener(this.onUpcomingChange);
    UserStore.removeChangeListener(this.onUserChange);
    document.removeEventListener('click', this._handleOutsideClick);
  }

  mailTicket(number) {
    this.setState({loading: true, resending: number, downloading: null});
    ReservationService.mailTicket(number)
    .then(() => {
      this.setState({loading: false, resending: null})
    })
    .catch((err) => {
      this.setState({loading: false, error: err.response.statusText, resending: null});
    });
  }

  createBlob(data, filename){
    var blob = new Blob([data], {type: 'application/pdf'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename);
    }
    else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }

  download(code) {
    this.setState({loading: true, downloading: code, resending: null});
    ReservationService.download(code)
    .then((result) => {
      this.createBlob(result.body, 'ticket.pdf');
      this.setState({loading: false, downloading: null});
    })
    .catch((err) => {
      this.setState({loading: false, error: err.toString(), downloading: null});
    });
  }

  editSeats(number) {
    browserHistory.push('/edit-trip?reservationNumber=' + number);
  }

  toggleSeatPopup(reservationNumber) {
    this.setState(function(prevState) {
      return {
        seatPopup: prevState.seatPopup === reservationNumber ? null : reservationNumber
      };
    });
  }

  render() {
    // TRIP-102: pending summary comes from the authoritative endpoint (matches the
    // admin panel, including completed trips awaiting tonight's cron); the sum over
    // upcoming trips is only a fallback while the backend lacks the endpoint.
    const reservations = this.state.reservations || [];
    const pendingPoints = this.state.pending ? this.state.pending.pendingPoints
      : reservations.reduce((sum, item) => sum + (item.pointsPending || 0), 0);
    const pendingTrips = this.state.pending ? this.state.pending.pendingTrips
      : reservations.filter((item) => (item.pointsPending || 0) > 0).length;
    return (
      this.state.user && <div className="overview">
        <div className="heading">Welcome <span>{this.state.user.firstName}</span></div>
        <div className="row clearfix vouchers">
          <div className="col-3">
            <div className="points">POINTS</div>
            <div className="pointsNum">{this.state.user.vouchers}</div>
            {pendingPoints > 0 &&
              <div style={{ fontSize: '13px', color: '#e8512f', fontWeight: 600 }}>
                +{pendingPoints} points pending from {pendingTrips} trip{pendingTrips === 1 ? '' : 's'}
              </div>}
          </div>
          <div className="col-3">
          <div className="points">CASH/CREDIT</div>
            <div className="pointsNum">${this.state.user.credit}</div>
          </div>
        </div>
        <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Points are rewarded after travel is completed.</div>
        <div>
          <div className="heading">Upcoming Trips</div>
          <div className="upcoming">
            {this.state.reservations && this.state.reservations.map((item, index) => {
              return (
                <div className="card" key={index}>
                  <div className="card-header">
                    <div className="res-number"><div className="only-desktop reservation-label">RESERVATION#</div> <span>{config.formatReservationNumber(item.reservationNumber)}</span>
                      {item.type === 'Elite' ? <div className="elite-bus-icon"><img height="15px" src={eliteIcon} alt="Premium Elite bus service booking"/></div> : null}
                    </div>
                    <div>
                      <a href="javascript:void(0)" className="view-history" onClick={this.props.setCurrentStep.bind(this, 2)}>View History</a>
                      <div className="dropdown dropdown-menu-right inline">
                        <a href="javascript:void(0)" className="dropdown-toggle options">Options <b className="caret"></b></a>
                        <ul className="dropdown-menu">
                          <li><a className={(this.state.resending === item.reservationNumber ? 'active': '')} href="javascript:void(0)" onClick={this.mailTicket.bind(this, item.reservationNumber)}>Re-send Email Confirmation</a></li>
                          <li><a className={(this.state.downloading === item.reservationNumber ? 'active': '')} href="javascript:void(0)" onClick={this.download.bind(this, item.reservationNumber)}>Print Ticket</a></li>
                          <li><a href="javascript:void(0)" onClick={this.editSeats.bind(this, item.reservationNumber)}>Reschedule Seat(s)</a></li>
                          <li><a href="javascript:void(0)" onClick={this.editSeats.bind(this, item.reservationNumber)}>Cancel Seat(s)</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row clearfix">
                      <div className="col-lg-7">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="sub-fields">DATE/TIME</div>
                            <div className="sub-fields-value">{moment(item.slot, 'YYYY-MM-DD').format('MM/DD/YY')} {moment(item.depart_stop.time, 'HH:mm:ss').format('hh:mm a')}</div>
                          </div>
                          <div className="col-sm-6">
                            <div className="sub-fields">ROUTE</div>
                            <div className="sub-fields-value">{this.getShortStopLabel(item.depart_stop.city)} to {this.getShortStopLabel(item.arrive_stop.city)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5">
                        <div className="row">
                          <div className="col-sm-3 col-6">
                            <div className="sub-fields">SEATS</div>
                            <div className="sub-fields-value">
                              {item.seats}
                              {item.seatNumbers && item.seatNumbers.length > 0 && (
                                <span className="seat-popup-wrapper" style={{ position: 'relative', display: 'inline-block', marginLeft: '5px' }}>
                                  <a
                                    href="javascript:void(0)"
                                    style={{ fontSize: '11px', color: '#e8512f', textDecoration: 'underline' }}
                                    onClick={this.toggleSeatPopup.bind(this, item.reservationNumber)}
                                  >
                                    View
                                  </a>
                                  {this.state.seatPopup === item.reservationNumber && (
                                    <div style={{
                                      position: 'absolute',
                                      bottom: '100%',
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      backgroundColor: '#333',
                                      color: '#fff',
                                      padding: '8px 12px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      whiteSpace: 'nowrap',
                                      zIndex: 10,
                                      marginBottom: '5px',
                                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                    }}>
                                      <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Seat Numbers</div>
                                      {item.seatNumbers.join(', ')}
                                      <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        width: 0,
                                        height: 0,
                                        borderLeft: '6px solid transparent',
                                        borderRight: '6px solid transparent',
                                        borderTop: '6px solid #333'
                                      }} />
                                    </div>
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3 col-6">
                            <div className="sub-fields">POINTS</div>
                            {/* Pending (red) only for legs the cron hasn't credited yet — trips booked
                                before TRIP-102 already got their points at booking time (green). */}
                            <div className="sub-fields-value" style={item.pointsPending > 0 ? { color: '#e8512f' } : (item.pointsEarned > 0 ? { color: '#6cbf4a' } : undefined)}>
                              +{item.pointsPending > 0 ? item.pointsPending : item.pointsEarned}
                              {item.pointsPending > 0 && <div style={{ fontSize: '11px', color: '#e8512f' }}>pending</div>}
                            </div>
                          </div>
                          <div className="col-sm-3 col-6">
                            <div className="sub-fields">TOTAL</div>
                            <div className="sub-fields-value">{numeral(item.ticketValue).format('$0,0[.]00')}</div>
                          </div>
                          <div className="col-sm-3 col-6">
                            <div className="sub-fields">STATUS</div>
                            <div className="sub-fields-value active">Active</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
            {this.state.loading &&
              <div className="fond">
                <div className="contener_general">
                  <div className="contener_mixte"><div className="ballcolor ball_1">&nbsp;</div></div>
                  <div className="contener_mixte"><div className="ballcolor ball_2">&nbsp;</div></div>
                  <div className="contener_mixte"><div className="ballcolor ball_3">&nbsp;</div></div>
                  <div className="contener_mixte"><div className="ballcolor ball_4">&nbsp;</div></div>
                </div>
              </div>
            }
          </div>
        </div>
        <div className="free-ticket-info">
            <div>Every {config.vouchersForFreeTicket} points equals a standard bus free ticket</div>
            <div className="youhaveearn">You have <span>{Math.floor(this.state.user.vouchers/config.vouchersForFreeTicket)}</span> free tickets (standard bus) and need <span>{config.vouchersForFreeTicket - (this.state.user.vouchers%config.vouchersForFreeTicket)}</span> more points to earn your next free ticket</div>
        </div>
      </div>
    )
  }
}

export default Overview;
